import React from "react";
import { useTranslation } from "react-i18next";
import Block from "../../Block";
import FormGroup from "../../forms/FormGroup";
import FormRowCol from "../../forms/FormRowCol";
import Select from "../../forms/inputs/Select";
import { CustomSwitch } from "../../components";

const formGroupWidthProps = {
  xs: 12,
  sm: 12,
  md: 12,
  lg: 8,
  xl: 6,
};

export default function PublisherScope({ getInputProps, formRefValues, formData }) {
  const { t } = useTranslation();

  return (
    <Block title={t("dataVendor.publisherScope")}> 
      <FormGroup
        as={FormRowCol}
        {...formGroupWidthProps}
        input={CustomSwitch}
        label={t("dataVendor.hasPublisherScope")}
        {...getInputProps("hasPublisherScope")}
      />
      {formData.hasPublisherScope && (
        <FormGroup
          label={t("dataVendor.publishers")}
          placeholder={t("pleaseSelect")}
          {...getInputProps("publisher_ids")}
        >
          <Select
            isMulti
            name="publisher_ids"
            options={formRefValues.publishers}
          />
        </FormGroup>
      )}
      {formData.hasPublisherScope &&
        formData.publisher_ids &&
        formData.publisher_ids.length > 0 && (
          <FormGroup
            label={t("dataVendor.blacklist")}
            placeholder={t("pleaseSelect")}
            as={FormRowCol}
            {...formGroupWidthProps}
            {...getInputProps("blacklist")}
          >
            <Select isClearable={true}>
              <option value="true" key="blacklist_true">
                {t("dataVendor.exclude")}
              </option>
              <option value="false" key="blacklist_false">
                {t("dataVendor.only")}
              </option>
            </Select>
          </FormGroup>
        )}
    </Block>
  );
}
